/*
 * BASEDODICI — Barra obiettivi carrello (doppia soglia)
 * ---------------------------------------------------------------------------
 * Mostra UNA barra con DUE traguardi nel carrello (drawer + pagina /cart):
 *
 *   1) 100 € -> Gadget B12 omaggio  (soglia reale: app EG Auto Add to Cart)
 *   2) 200 € -> Spedizione gratis   (soglia reale: Admin > Spedizioni)
 *
 * La barra si riempie da 0 fino al traguardo 2; una tacca segna il traguardo 1.
 * Il messaggio cambia da solo nei tre stati.
 *
 * Questo file NON modifica theme.js. Legge il subtotale dal DOM del tema
 * ([data-cart-total], in centesimi) e si riaggancia quando il tema ridisegna
 * il carrello o clona il drawer dal suo <template>.
 *
 * >>> PER CAMBIARE SOGLIE E TESTI: modifica solo il blocco CONFIG. <<<
 * Gli importi sono in EURO interi.
 *
 * ATTENZIONE: questa barra mostra soltanto il messaggio. Non applica sconti.
 * Se cambi una soglia qui, cambiala anche dove viene applicata davvero
 * (Spedizioni per la 1, app EG Auto Add to Cart per la 2).
 * ---------------------------------------------------------------------------
 */

(function () {
  'use strict';

  /* ===================== CONFIG ===================== */
  var CONFIG = {
    goal1: 100,
    goal2: 200,
    label1: 'Gadget B12',
    label2: 'Spedizione gratis',
    icon1: '🎁', // regalo
    icon2: '🚚', // camion
    accent: '#e1ff00',
    // ||amount|| viene sostituito con quanto manca al traguardo
    msg1: 'Ti mancano <strong>||amount||</strong> per il <strong>GADGET B12</strong> in omaggio',
    msg2: 'Gadget B12 sbloccato. Ancora <strong>||amount||</strong> e la <strong>SPEDIZIONE</strong> è <strong>GRATIS</strong>',
    msg3: 'Gadget B12 in omaggio <strong>+</strong> Spedizione gratis: sbloccati entrambi'
  };
  /* =================== FINE CONFIG =================== */

  if (window.__b12CartGoals) return;
  window.__b12CartGoals = true;

  var G1 = CONFIG.goal1 * 100; // centesimi
  var G2 = CONFIG.goal2 * 100;

  if (!(G1 > 0 && G2 > G1)) {
    console.warn('[b12-goals] Soglie non valide: goal2 deve essere maggiore di goal1.');
    return;
  }

  var MOUNT = '[data-foot-holder]';
  var BAR = 'b12-goals';
  var lastDom = null;      // ultimo subtotale letto dal DOM del tema
  var lastPainted = null;  // ultimo subtotale effettivamente disegnato
  var lastMounted = -1;
  var timer = null;
  var verifyTimer = null;
  var verifying = false;

  /* ---------- stile ---------- */

  function injectStyles() {
    if (document.getElementById('b12-goals-styles')) return;
    var css = [
      /* nasconde la barra nativa a soglia singola; resta nel DOM cosi'
         theme.js continua a girare senza errori */
      '[data-cart-message]{display:none !important}',
      '.' + BAR + '{--b12-accent:' + CONFIG.accent + ';--b12-track:rgba(128,128,128,.22);' +
        'margin:0 0 18px;font-size:13px;line-height:1.35;color:inherit}',
      '.' + BAR + '--empty{display:none}',
      '.' + BAR + '__msg{margin:0 0 9px;text-align:center;letter-spacing:.01em}',
      '.' + BAR + '__msg strong{font-weight:700}',
      '.' + BAR + '__track{position:relative;height:8px;border-radius:999px;' +
        'background:var(--b12-track);overflow:hidden}',
      '.' + BAR + '__fill{position:absolute;top:0;left:0;bottom:0;width:0;border-radius:999px;' +
        'background:currentColor;transition:width .45s cubic-bezier(.25,.8,.25,1),background-color .3s ease}',
      '.' + BAR + '.is-g2 .' + BAR + '__fill{background:var(--b12-accent)}',
      '.' + BAR + '__tick{position:absolute;top:0;bottom:0;width:2px;margin-left:-1px;' +
        'background:var(--COLOR-BODY-BG,#fff);opacity:.9}',
      '.' + BAR + '.is-g2 .' + BAR + '__tick{opacity:0}',
      '.' + BAR + '__legend{display:flex;justify-content:space-between;gap:10px;margin-top:7px;' +
        'font-size:11px;letter-spacing:.05em;text-transform:uppercase}',
      '.' + BAR + '__goal{display:inline-flex;align-items:center;gap:4px;opacity:.5;transition:opacity .3s ease}',
      '.' + BAR + '__goal.is-reached{opacity:1;font-weight:700}',
      '.' + BAR + '__ico{font-size:13px;line-height:1}',
      '@media (prefers-reduced-motion:reduce){.' + BAR + '__fill{transition:none}}'
    ].join('');

    var style = document.createElement('style');
    style.id = 'b12-goals-styles';
    style.appendChild(document.createTextNode(css));
    (document.head || document.documentElement).appendChild(style);
  }

  /* ---------- utility ---------- */

  function currencyRate() {
    try {
      var r = parseFloat(window.Shopify.currency.rate);
      return r > 0 ? r : 1;
    } catch (e) { return 1; }
  }

  function activeCurrency() {
    try { return window.Shopify.currency.active || 'EUR'; } catch (e) { return 'EUR'; }
  }

  function formatMoney(cents) {
    var value = Math.max(0, cents) / 100;
    var hasDecimals = Math.round(value * 100) % 100 !== 0;
    try {
      return new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: activeCurrency(),
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: 2
      }).format(value);
    } catch (e) {
      return '€' + (hasDecimals ? value.toFixed(2).replace('.', ',') : value.toFixed(0));
    }
  }

  function readSubtotal() {
    var el = document.querySelector('[data-cart-total]');
    if (el) {
      var parsed = parseInt(el.getAttribute('data-cart-total'), 10);
      if (!isNaN(parsed)) return parsed;
    }
    if (window.theme && typeof window.theme.subtotal === 'number') return window.theme.subtotal;
    return 0;
  }

  /* ---------- markup ---------- */

  function buildBar() {
    var tickPct = (G1 / G2) * 100;
    var el = document.createElement('div');
    el.className = BAR + ' ' + BAR + '--empty';
    el.setAttribute('data-b12-goals', '');
    el.innerHTML =
      '<p class="' + BAR + '__msg" data-b12-msg aria-live="polite"></p>' +
      '<div class="' + BAR + '__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0" data-b12-track>' +
        '<span class="' + BAR + '__fill" data-b12-fill></span>' +
        '<span class="' + BAR + '__tick" style="left:' + tickPct + '%" aria-hidden="true"></span>' +
      '</div>' +
      '<div class="' + BAR + '__legend">' +
        '<span class="' + BAR + '__goal" data-b12-goal="1">' +
          '<span class="' + BAR + '__ico" aria-hidden="true">' + CONFIG.icon1 + '</span>' +
          CONFIG.label1 + ' · ' + formatMoney(G1) +
        '</span>' +
        '<span class="' + BAR + '__goal" data-b12-goal="2">' +
          '<span class="' + BAR + '__ico" aria-hidden="true">' + CONFIG.icon2 + '</span>' +
          CONFIG.label2 + ' · ' + formatMoney(G2) +
        '</span>' +
      '</div>';
    return el;
  }

  // Inserisce la barra in cima a ogni contenitore carrello che non ce l'ha ancora
  function mount() {
    var holders = document.querySelectorAll(MOUNT);
    for (var i = 0; i < holders.length; i++) {
      if (!holders[i].querySelector('[data-b12-goals]')) {
        holders[i].insertBefore(buildBar(), holders[i].firstChild);
      }
    }
    return holders.length;
  }

  /* ---------- render ---------- */

  function paint(subtotal) {
    var multiplier = currencyRate();
    var g1 = G1 * multiplier;
    var g2 = G2 * multiplier;
    var pct = Math.max(0, Math.min(100, (subtotal / g2) * 100));

    var html;
    if (subtotal < g1) {
      html = CONFIG.msg1.replace('||amount||', formatMoney(g1 - subtotal));
    } else if (subtotal < g2) {
      html = CONFIG.msg2.replace('||amount||', formatMoney(g2 - subtotal));
    } else {
      html = CONFIG.msg3;
    }

    var roots = document.querySelectorAll('[data-b12-goals]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];

      var fill = root.querySelector('[data-b12-fill]');
      if (fill) fill.style.width = pct + '%';

      var track = root.querySelector('[data-b12-track]');
      if (track) track.setAttribute('aria-valuenow', Math.round(pct));

      var msg = root.querySelector('[data-b12-msg]');
      if (msg && msg.innerHTML !== html) msg.innerHTML = html;

      root.classList.toggle(BAR + '--empty', subtotal <= 0);
      root.classList.toggle('is-g1', subtotal >= g1);
      root.classList.toggle('is-g2', subtotal >= g2);

      var d1 = root.querySelector('[data-b12-goal="1"]');
      var d2 = root.querySelector('[data-b12-goal="2"]');
      if (d1) d1.classList.toggle('is-reached', subtotal >= g1);
      if (d2) d2.classList.toggle('is-reached', subtotal >= g2);
    }
  }

  function sync() {
    injectStyles();
    var mounted = mount();
    var dom = readSubtotal();
    var domChanged = dom !== lastDom;
    var mountedChanged = mounted !== lastMounted;
    lastDom = dom;
    lastMounted = mounted;

    // Esce subito se nulla e' cambiato. Serve anche a spezzare il ciclo
    // paint() -> MutationObserver -> sync(), oltre a tenere basso il costo.
    if (!domChanged && !mountedChanged) return;

    // Se il DOM e' cambiato e' la fonte piu' fresca. Se invece sono solo
    // comparsi nuovi contenitori (drawer clonato dal <template>), si ridisegna
    // il valore gia' noto: cosi' non si sovrascrive una correzione di verify()
    // con un [data-cart-total] ancora stale.
    if (domChanged || lastPainted === null) lastPainted = dom;
    paint(lastPainted);
  }

  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; sync(); }, 60);
  }

  // Sorgente di verita': /cart.js. Serve perche' app di terze parti
  // (es. EG Auto Add to Cart, che lavora proprio sulla soglia da 100 €)
  // possono cambiare il carrello senza far ridisegnare il DOM del tema.
  function verify() {
    if (verifying || !window.fetch) return;
    verifying = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) {
        if (cart && typeof cart.total_price === 'number' && cart.total_price !== lastPainted) {
          lastPainted = cart.total_price;
          lastMounted = mount();
          paint(cart.total_price);
        }
      })
      .catch(function () { /* offline o risposta non valida: si tiene il valore dal DOM */ })
      .then(function () { verifying = false; });
  }

  function scheduleVerify() {
    if (verifyTimer) clearTimeout(verifyTimer);
    verifyTimer = setTimeout(function () { verifyTimer = null; verify(); }, 450);
  }

  /* ---------- agganci ---------- */

  ['theme:cart:added', 'theme:cart:loaded', 'theme:cart:open', 'theme:cart:update']
    .forEach(function (name) {
      document.addEventListener(name, function () { schedule(); scheduleVerify(); }, true);
    });

  if (window.MutationObserver) {
    var startObserver = function () {
      new MutationObserver(schedule).observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-cart-total']
      });
    };
    if (document.body) startObserver();
    else document.addEventListener('DOMContentLoaded', startObserver);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
